import { SETTINGS_SET_TRANSLATIONS } from "../actions/settings";

const defaultState = {
    translations: {},
    language: null
}

export const settingsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SETTINGS_SET_TRANSLATIONS: return { state, translations: action.translations, language: action.language }
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/settings.js